/**
 * Fraud Review Page
 * 
 * Main page for reviewing and managing fraud-held payments.
 */

import type { FC } from 'react';
import { Shield } from 'lucide-react';
import { DashboardShell } from '../components/layout/DashboardShell';
import { FraudQueue } from '../components/fraud/FraudQueue';
import { BreadcrumbNav } from '../components/layout/BreadcrumbNav';

export const FraudReviewPage: FC = () => {
  const customerId = 'current'; // In real app, get from auth context

  return (
    <DashboardShell customer={{ id: 'cust-123', businessName: 'Demo Company', onboardingStatus: 'approved', isOnboarded: true, ledgerBalanceCents: 1000000, ledgerBalanceDollars: 10000 }}>
      <BreadcrumbNav
        items={[
          { label: 'Dashboard', path: '/' },
          { label: 'Fraud Review' },
        ]}
      />

      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 flex items-center">
              <Shield className="w-7 h-7 mr-3 text-orange-500" />
              Fraud Review Queue
            </h1>
            <p className="text-gray-600 mt-1">
              Review, approve, or deny payments flagged for fraud review
            </p>
          </div>
        </div>

        {/* Fraud Queue */}
        <FraudQueue customerId={customerId} />
      </div>
    </DashboardShell>
  );
};

export default FraudReviewPage;
